export enum EScopeType {
    LabSite = 1,
    BusinessUnitCluster = 2,
    NationalBusinessLine = 3,
    All = 4
}
